import React from 'react';
import Aux from '../../Hoc/Aux/Aux';
import Hero from '../UI/Hero/Hero';
import whyusImg from '../../Assets/Images/whyus.png';
import Footer from '../Footer/Footer';

const curriculum = (props) => {
    return(
        <Aux>
            <Hero title="We Transform Careers"
                  subtitle="THE PROCODE ADVANTAGE"
                  classType="hero-overview"
                  img={whyusImg}
            />

            <section></section>
            <Aux>
                <Footer />
            </Aux>
        </Aux>
    )
};

export default curriculum;


// WEBPACK FOOTER //
// ./src/Components/WhyUs/WhyUs.js